import { Component, Input, OnInit, SimpleChanges, OnChanges, ChangeDetectionStrategy } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-announcement-detail',
  templateUrl: './announcement-detail.component.html',
  styleUrls: ['./announcement-detail.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AnnouncementDetailComponent implements OnInit, OnChanges {

  @Input()
  announcement: any;

  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit() {
    //
  }

  trustUrl(url: any): any {
    if (url) {
      return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    // let announcement = changes['announcement'].currentValue;
    // if (this.announcement && this.announcement.url) {
    //   this.announcement.safeUrl = this.sanitizer.bypassSecurityTrustUrl(this.announcement.url);
    // };
    // changes.prop contains the old and the new value...
  }
}



// WEBPACK FOOTER //
// /ng-app/src/app/announcements/announcement-detail/announcement-detail.component.ts